import { useState } from "react";
import { useDispatch } from "react-redux";

import {
  RegionOfInterestAnnotation,
  ViewerMode,
} from "custom-models/ViewerTypes";

import { changeViewerMode } from "shared/actions/slideDetailActions";
import {
  LESION_LINE_NAMES,
  LESION_LINE_TYPE_HIERARCHY,
} from "shared/reducers/aiReducer";

import "./LesionLineTypeSelectionDialog.css";

interface LesionLineTypeSelectionDialogProps {
  annotation: RegionOfInterestAnnotation;
  lesionLineType: string;
  onAnnotationComplete: (ann: RegionOfInterestAnnotation) => void;
}

const LesionLineTypeSelectionDialog = (
  props: LesionLineTypeSelectionDialogProps
) => {
  const { annotation, lesionLineType, onAnnotationComplete } = props;

  const [subtype, setSubtype] = useState<string | undefined>();

  const lesionLineSubtypes = LESION_LINE_TYPE_HIERARCHY[lesionLineType] || {};

  const dispatch = useDispatch();

  return (
    <div>
      <form
        className="LesionLineTypeSelectionDialog"
        onSubmit={(e) => {
          e.preventDefault();
          if (!subtype) {
            onAnnotationComplete(annotation);
          } else {
            onAnnotationComplete({
              ...annotation,
              subtype,
            });
          }
          dispatch(changeViewerMode(ViewerMode.PAN_ZOOM));
        }}
      >
        <h3>REGION OF INTEREST</h3>
        <div>
          LESION TYPE: {lesionLineType} (
          {LESION_LINE_NAMES[lesionLineType || ""]})
        </div>
        <div className="LesionLineTypeSelectionDialog__subtype">
          <label>SUBTYPE</label>
          <select
            disabled={Object.keys(lesionLineSubtypes).length === 0}
            name="subtype"
            id="subtype"
            value={subtype}
            onChange={(e) => {
              setSubtype(e.target.value);
            }}
            required
          >
            <option value="">Not Specified</option>
            {Object.entries(lesionLineSubtypes).map(([code, name]) => (
              <option key={code} value={code}>{`${code}: ${name}`}</option>
            ))}
          </select>
        </div>
        <nav>
          <button type="submit">OK</button>
          <button
            onClick={() => {
              dispatch(changeViewerMode(ViewerMode.PAN_ZOOM));
            }}
          >
            CANCEL
          </button>
        </nav>
      </form>
    </div>
  );
};

export default LesionLineTypeSelectionDialog;
